/* global $ */
import React, { useCallback, useRef } from 'react';
const Ripple = ({ children, childRefProp = 'ref', childRef = null, }) => {
    const $el = useRef(null);
    const handleRef = useCallback((el) => {
        if ($el.current) {
            $el.current.ripple({ unbind: true });
            $el.current = null;
        }
        if (el) {
            $el.current = $(el);
            $el.current.ripple();
        }
        if (childRef) {
            childRef = $(el);
        }
    }, [$el, childRef]);
    if (typeof children.type === 'function' && childRefProp === 'ref') {
        return React.cloneElement(children);
    }
    return React.cloneElement(children, {
        [childRefProp]: handleRef,
    });
};
export default Ripple;
